import React from 'react';
import {Button, BUTTON_SIZE} from '@time-webkit/all/atoms/button';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {useIntl} from 'react-intl';

import styles from './styles.module.css';

export const LegacyTryAgain: React.FunctionComponent<{retry: () => void}> = (props) => {
    const {formatMessage} = useIntl();
    const typographyCls = useTypography({size: TypographySize.BodyL});
    const buttonLabel = formatMessage({id: 'apps.error.try_again', defaultMessage: 'Try again'});

    return (
        <div className={styles.errorWrapper}>
            <span className={typographyCls}>
                {formatMessage({id: 'apps.error.smth_went_wrong', defaultMessage: 'Something went wrong'})}
            </span>
            <Button
                size={BUTTON_SIZE.SMALL}
                onPress={props.retry}
                aria-label={buttonLabel}
            >
                {buttonLabel}
            </Button>
        </div>
    );
};
